import { Directive, ViewContainerRef } from "@angular/core";

@Directive({
    selector: '[componentHost]'
})
export class ComponentLoaderDirective {
    constructor(public viewContainerRef: ViewContainerRef) { }
}